import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import _ from 'lodash'
import moment from 'moment';
import api from '../helpers/apiClient';
import { Link } from 'react-router-dom';
import { Button, Badge, Accordion, Card, Row, Col, Container, Form, ProgressBar } from 'react-bootstrap';
import Loader from '../components/Loader';
import MobileDetect from 'mobile-detect'
import ConfirmModal from '../components/ConfirmModal';
import * as billingsActionCreators from '../redux/actions/billings';
import { DateRangePicker,  DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import ReactTooltip from 'react-tooltip';
import config from '../config'
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro'
import PaymentDateModal from '../components/PaymentDateModal';
import TabHeader from '../components/TabHeader';

const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;

const currency = window.location.hostname === 'seller.giftr.my' ? 'RM' : 'S$'

const fulfillmentStatusOptions = {
  any: 'Any',
  fulfilled: 'Fulfilled',
  unfulfilled: 'Unfulfilled',
  partial: 'Partial'
};

const financialStatusOptions = {
  any: 'Any',
  authorized: 'Authorized',
  pending: 'Pending',
  paid: 'Paid',
  partially_paid: 'Partially Paid',
  refunded: 'Refunded',
  voided: 'Voided',
};

class Billings extends Component {
  constructor(props) {
    super(props);
    const { location } = props;
    let financialStatus = 'any';
    let fulfillmentStatus = 'any';
    let startDate, endDate, generateBillingPeriod, generatingBill, exportMonthlyBillName, exportingBill
    if (location.search) {
      const { financial_status, fulfillment_status } = qs.parse(location.search.substr(1));
      const queryString = qs.parse(location.search.substr(1));

      if (queryString.financial_status) {
        financialStatus = queryString.financial_status;
      }
      if (queryString.fulfillment_status) {
        fulfillmentStatus = queryString.fulfillment_status;
      }
      if (queryString.start_date) {
        startDate = moment(queryString.start_date, 'D-M-YY');
      }
      if (queryString.end_date) {
        endDate = moment(queryString.end_date, 'D-M-YY');
      }
    }

    this.state = {
      financialStatus,
      fulfillmentStatus,
      startDate,
      endDate,
      generateBillingPeriod,
      generatingBill,
      exportMonthlyBillName,
      startMonthName: '',
      endMonthName: '',
      exportingBill,
      showConfirmBillModal: false,
      selectedUnbilledIds: [],
      selectedBilledIds: [],
      showUpdatePaymentDateModal: false,
      deadLetter: [],
      deadLetterLoading: false,
      deadLetterError: null,
      statusFilter: 'all',
      confirming: false,
      confirmTotal: 0,
      confirmStartedAt: null,
      queueActive: [],
      queueQueued: [],
      queueWorking: false,
    };
    this.confirmPollTimer = null;
  }

  componentDidMount() {
    const { fetchBillings, location, user } = this.props;
    const { merchantId, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date } = qs.parse(location.search.substr(1));
    const { email, role } = user
    fetchBillings(email, role, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date);
    if (role === 'admin' || role === 'staff') {
      this.fetchDeadLetter();
    }
  }

  componentWillUnmount() {
    this.stopConfirmPolling();
  }

  startConfirmPolling = () => {
    this.stopConfirmPolling();
    this.confirmPollTimer = setInterval(() => {
      this.pollConfirmProgress();
    }, 2000);
  }

  stopConfirmPolling = () => {
    if (this.confirmPollTimer) {
      clearInterval(this.confirmPollTimer);
      this.confirmPollTimer = null;
    }
  }

  getConfirmRemaining = () => {
    const { confirmTotal, queueActive, queueQueued } = this.state;
    const remaining = (queueActive || []).length + (queueQueued || []).length;
    return Math.min(confirmTotal || 0, remaining);
  }

  pollConfirmProgress = () => {
    const { confirming, confirmStartedAt } = this.state;
    if (!confirming) {
      this.stopConfirmPolling();
      return Promise.resolve();
    }
    // Give up polling after ~10 minutes; the queue keeps working server-side.
    if (confirmStartedAt && Date.now() - confirmStartedAt > 10 * 60 * 1000) {
      this.stopConfirmPolling();
      this.setState({ confirming: false });
      return this.fetchDeadLetter();
    }
    return this.fetchDeadLetter().then(() => {
      const { confirming: stillConfirming, queueWorking } = this.state;
      if (stillConfirming && !queueWorking && this.getConfirmRemaining() === 0) {
        this.stopConfirmPolling();
        this.setState({ confirming: false });
        this.refreshBillings();
      }
    });
  }

  refreshBillings = () => {
    const { fetchBillings, location, user } = this.props;
    const { merchantId, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date } = qs.parse(location.search.substr(1));
    const { email, role } = user
    fetchBillings(email, role, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date);
  }

  fetchDeadLetter = () => {
    this.setState({ deadLetterLoading: true, deadLetterError: null });
    return api('/bills/dead_letter', { method: 'GET' }).then((result) => {
      this.setState({
        deadLetterLoading: false,
        deadLetter: (result && result.dead_letter) || [],
        queueActive: (result && result.active) || [],
        queueQueued: (result && result.queued) || [],
        queueWorking: !!(result && result.working),
      });
    }).catch((err) => {
      this.setState({ deadLetterLoading: false, deadLetterError: (err && err.message) || 'Failed to load failed bills' });
    });
  }

  handleRequeueDeadLetter = (billId) => {
    // A single retry also runs through the background queue; track it with
    // the same progress bar so confirm feedback is consistent.
    this.stopConfirmPolling();
    this.setState({
      confirming: true,
      confirmTotal: Math.max(1, (this.state.confirmTotal || 0) - this.getConfirmRemaining() + 1),
      confirmStartedAt: Date.now(),
    });
    return api(`/bills/dead_letter/${billId}/requeue`, { method: 'POST' }).then(() => {
      return this.fetchDeadLetter();
    }).then(() => {
      this.startConfirmPolling();
      return this.pollConfirmProgress();
    }).catch((err) => {
      this.stopConfirmPolling();
      this.setState({ confirming: false });
      alert((err && err.message) || 'Failed to requeue bill');
    });
  }

  handleClearDeadLetter = () => {
    return api('/bills/dead_letter', { method: 'DELETE' }).then(() => {
      return this.fetchDeadLetter();
    }).catch((err) => {
      alert((err && err.message) || 'Failed to clear failed bills');
    });
  }

  componentWillReceiveProps(nextProps) {
    const { location: prevLocation } = this.props;
    const { fetchBillings, location } = nextProps;
    if (location.search !== prevLocation.search) {
      const { merchantId, financial_status, fulfillment_status, limit, createdAtMax, start_date ,end_date} = qs.parse(location.search.substr(1));
      fetchBillings(merchantId, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date);
      this.setState({
        financialStatus: financial_status || 'any',
        fulfillmentStatus: fulfillment_status || 'any'
      });
    }
  }

  renderDetailLink = (cell, row) => {

    let pathname = row.is_v2_billing ? `/bills/${row._id}` : `/legacy_bills/${row._id}`

    return (
      <Link
        key={row.id}
        to={{
          pathname,
          state: {modal: false}
        }}
      >
        {row.name}
      </Link>
    )
  }

  renderInvoiceNumber = (cell, row) => {

    return (
      <a
        target="_blank"
        href={row.invoice_link}>
        {cell}
      </a>
    )
  }

  exportDetailLink = (cell, row) => {

    return row.name
  }

  exportTax = (cell, row) => {

    return row.gst
  }

  renderPrice = (cell, row) => {

    return <span>{currency} {cell ? cell.toFixed(2) : "0.00"}</span>
  }

  exportCommission = (cell, row) => {

    return row.commission
  }

  renderCommission = (cell, row) => {

    return <span>{currency} {row.commission.toFixed(2)}</span>
  }

  renderGst = (cell, row) => {

    return <span>{currency} {row.gst.toFixed(2)}</span>
  }

  renderShipping = (cell, row) => {

    return <span>{currency} {row.total_shipping.toFixed(2)}</span>
  }

  renderDiscount = (cell, row) => {

    return <span>{currency} {row.total_discount.toFixed(2)}</span>
  }

  renderStatus = (cell, row) => {

    return row.status === 'paid' ?
      <Badge bg="success" className="text-uppercase">{row.status}</Badge>
      :
      <Badge bg="warning" className="text-uppercase">{row.status}</Badge>
  }

  renderEInvoice = (cell, row) => {

    return cell ?
      <Badge bg="success" className="text-uppercase">Yes</Badge>
      :
      <Badge bg="secondary" className="text-uppercase">No</Badge>
  }

  renderBillingDate = (options, onChange) => {

    const { generateBillingPeriod } = this.state;

    return (
      <select className="form-control" onChange={onChange}>
        <option key="1" value="" selected hidden>Please select billing period</option>
        {
          options.map(option => {
            return (<option key={option.format('YYYY-MM-DD')} value={option.format('YYYY-MM-DD')}>{option.format('MMM YYYY')}</option>)
          })
        }
      </select>
    )
  }

  renderBillName= (options, onChange) => {

    const { exportMonthlyBillName } = this.state;

    return (
      <select className="form-control" onChange={onChange}>
        <option key="1" value="" hidden>Select billing period</option>
        {
          options.map(option => {
            return (<option key={option.format('MMM YYYY')} value={option.format('MMM YYYY')}>{option.format('MMM YYYY')}</option>)
          })
        }
      </select>
    )
  }

  handleOnPeriodChange = (e) => {

    this.setState({
      generateBillingPeriod: e.target.value,
    });
  }

  handleOnExportBillNameChange = (e) => {

    this.setState({
      exportMonthlyBillName: e.target.value,
    });
  }

  handleGenerateBill = () => {
    const { generateBillingPeriod } = this.state;
    const { fetchBillings, location, user } = this.props;
    const { merchantId, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date } = qs.parse(location.search.substr(1));
    const { email, role } = user

    if(!generateBillingPeriod){
      return;
    }

    this.setState({
      generatingBill: true,
    });

    return api(`/billing/generate/${generateBillingPeriod}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(() => {
      fetchBillings(email, role, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date);
    }).catch(err => {
      if (err) {
        const { addError } = this.props;
        if (err.validationError) {
          addError(err.validationError);
        }
        else if (err.message) {
          addError(err.message);
        }
        else {
          addError(err);
        }
      }
    });
  }

  handleExportMonthlyBill = () => {
    const { exportMonthlyBillName } = this.state;

    if(!exportMonthlyBillName){
      return;
    }

    this.setState({
      exportingBill: true,
    });

    return api(`/bills/export/month`, {
      method: 'POST',
      body: JSON.stringify({'billName': exportMonthlyBillName})
    }, {'Accept': 'application/json', 'Content-Type': 'application/json'}).then((result) => {

      if(result.url){
        window.location.href = result.url;
      }

      this.setState({
        exportingBill: false,
      });
    }).catch(err => {
      if (err) {
        const { addError } = this.props;
        if (err.validationError) {
          addError(err.validationError);
        }
        else if (err.message) {
          addError(err.message);
        }
        else {
          addError(err);
        }
      }
    });
  }

  onRowSelect = (row, isSelected) => {

    let { selectedUnbilledIds, selectedBilledIds } = this.state;
    let { billings: { unbilledRows, billedRows } } = this.props;

    if(isSelected){
      if(_.some(unbilledRows, u => u === row._id)){
        selectedUnbilledIds.push({id: row._id});
      }

      if(_.some(billedRows, u => u === row._id)){
        selectedBilledIds.push({
          id: row._id,
          vendor: row.vendor,
          name: row.name,
        });
      }
    } else {
      selectedUnbilledIds = _.reject(selectedUnbilledIds, {id: row._id})
      selectedBilledIds = _.reject(selectedBilledIds, {id: row._id})
    }

    this.setState({ selectedUnbilledIds, selectedBilledIds });
  }

  onSelectAll = (isSelected, rows) => {
    let { billings: { unbilledRows, billedRows } } = this.props;

    let { selectedUnbilledIds, selectedBilledIds } = this.state;
    let nextUnbilledIds = [...selectedUnbilledIds];
    let nextBilledIds = [...selectedBilledIds];

    if(isSelected){
      for (let i = 0; i < rows.length; i++){
        if(_.some(unbilledRows, u => u === rows[i]._id) && !_.some(nextUnbilledIds, {id: rows[i]._id})){
          nextUnbilledIds.push({id: rows[i]._id});
        }

        if(_.some(billedRows, u => u === rows[i]._id) && !_.some(nextBilledIds, {id: rows[i]._id})){
          nextBilledIds.push({
            id: rows[i]._id,
            vendor: rows[i].vendor,
            name: rows[i].name,
          });
        }
      }
    } else {
      const visibleIds = _.map(rows, r => r._id);
      nextUnbilledIds = _.reject(nextUnbilledIds, s => _.includes(visibleIds, s.id));
      nextBilledIds = _.reject(nextBilledIds, s => _.includes(visibleIds, s.id));
    }

    this.setState({ selectedUnbilledIds: nextUnbilledIds, selectedBilledIds: nextBilledIds });

    if(!isSelected){
      return [];
    }
  }

  handleOnClickConfirmBill = () => {
    this.setState({ showConfirmBillModal: true });
  }

  handleOnCloseConfirmBillModal = () => {
    this.setState({ showConfirmBillModal: false });
  }

  handleConfirmBills = () => {

    const { selectedUnbilledIds } = this.state;

    let ids = _.map(selectedUnbilledIds, (bill) => {
      return bill.id
    })

    if (ids.length === 0) {
      return Promise.resolve();
    }

    let body = { bill_ids : ids }

    this.stopConfirmPolling();
    this.setState({
      loading: false,
      showConfirmBillModal: false,
      selectedUnbilledIds: [],
      selectedBilledIds: [],
      confirming: true,
      confirmTotal: ids.length,
      confirmStartedAt: Date.now(),
    });

    return api(`/bills/bulk_confirm`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    }).then(() => {
      this.refreshBillings();
      return this.fetchDeadLetter();
    }).then(() => {
      this.startConfirmPolling();
      return this.pollConfirmProgress();
    }).catch(err => {
      this.stopConfirmPolling();
      this.setState({ loading: false, confirming: false });
      if (err) {
        window.scrollTo(0, 0);
        alert(err.message);
      }
    });

  }

  handleStartPeriodChange = e => {
    let { endMonthName } = this.state;
    const { value } = e.target;

    if(endMonthName !== '' && moment(endMonthName, 'MMM YYYY').isBefore(moment(value, 'MMM YYYY'))){
      endMonthName = value
    } else if (endMonthName === ''){
      endMonthName = value
    }

    this.setState({
      endMonthName,
      startMonthName: value,
    });
  }

  handleEndPeriodChange = e => {
    let { startMonthName } = this.state;
    const { value } = e.target;

    if(startMonthName !== '' && moment(startMonthName, 'MMM YYYY').isAfter(moment(value, 'MMM YYYY'))){
      startMonthName = value
    } else if (startMonthName === ''){
      startMonthName = value
    }

    this.setState({
      startMonthName,
      endMonthName: value,
    });
  }

  handleResetFilter = () => {
    this.setState({
      startMonthName: '',
      endMonthName: '',
      statusFilter: 'all',
    });
  }

  handleStatusFilterChange = (statusFilter) => {
    this.setState({ statusFilter });
  }

  handleOnClickFilter = () => {
    const { fetchBillings, user } = this.props;
    const { email, role } = user
    const { startMonthName, endMonthName } = this.state;
    let { financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date } = qs.parse(location.search.substr(1));

    if(startMonthName && endMonthName){
      let start_date = moment(startMonthName, 'MMM YYYY').format()
      let end_date = moment(endMonthName, 'MMM YYYY').format()

      fetchBillings(email, role, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date);
    }
  }

  handleOnClickUpdatePaymentDate = () => {
    this.setState({ showUpdatePaymentDateModal: true });
  }

  handleOnCloseShowPaymentDateModal = () => {
    this.setState({ showUpdatePaymentDateModal: false });
  }

  handleSetPaymentDate = async (payment_date) => {
    if(!payment_date){
      return
    }
    const { selectedBilledIds } = this.state;

    let bill_ids = _.map(selectedBilledIds, (bill) => {
      return bill.id
    })

    return api('/bills/bulk_payment_date' , {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ bill_ids, payment_date }),
    }).then(result => {
      if(result.success){
        this.setState({ showUpdatePaymentDateModal: false, selectedBilledIds: [], selectedUnbilledIds: [] });
        this.componentDidMount();
      } else {
        console.log(result.error);
      }
    }).catch(err =>{
      console.log(err)
    })
  }

  render() {
    const { billings: { loading, loaded, items, first_bill_month, next, unselectableRows }, location: { pathname, search, routeState }, previousRoutes, previousPreviousRoutes, previousRoutePathName, previousRouteSearch, user } = this.props;
    const { fulfillmentStatus, financialStatus, generatingBill, exportingBill, showConfirmBillModal, startMonthName, endMonthName, selectedUnbilledIds, selectedBilledIds, showUpdatePaymentDateModal, deadLetter, deadLetterLoading, deadLetterError, statusFilter, confirming, confirmTotal, queueActive, queueQueued, queueWorking } = this.state;
    const confirmRemaining = this.getConfirmRemaining();
    const confirmDone = Math.max(0, (confirmTotal || 0) - confirmRemaining);
    const confirmPct = confirmTotal > 0 ? Math.round((confirmDone / confirmTotal) * 100) : 0;
    const hasQueuedJobs = queueWorking || (queueActive || []).length > 0 || (queueQueued || []).length > 0 || confirming;
    const showFailedBillsSection = deadLetterLoading || deadLetterError || (deadLetter || []).length > 0 || hasQueuedJobs;

    const isAdmin = user.role === 'admin'
    const isStaff = user.role === 'staff'

    let firstBillMonth = moment(first_bill_month, 'MMM YYYY')
    let historicalRange = moment().diff(firstBillMonth, 'months')

    let period = []
    for(let i = 1; i <= historicalRange; i++){
      let month = moment().subtract(i, 'months')
      period.push(month)
    }

    const safeItems = items || [];
    const statusCounts = {
      all: safeItems.length,
      unbilled: safeItems.filter(b => b.status === 'unbilled').length,
      billed: safeItems.filter(b => b.status === 'billed').length,
      paid: safeItems.filter(b => b.status === 'paid').length,
    };
    const filteredItems = statusFilter === 'all' ? safeItems : safeItems.filter(b => b.status === statusFilter);
    const selectedRowKeys = [
      ..._.map(selectedUnbilledIds, b => b.id),
      ..._.map(selectedBilledIds, b => b.id),
    ];

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: true,
      selected: selectedRowKeys,
      onSelect: this.onRowSelect,
      onSelectAll: this.onSelectAll,
      // nonSelectable: unselectableRows,
      headerColumnStyle: { width: '30px' },
    }

    const options = {
      showTotal: true,
      sizePerPage: 20,
      sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }, {
        text: 'All', value: filteredItems.length || 1
      }],
    };

    const columns = [
      {
        dataField: '_id',
        headerStyle: {
          width: '100px',
          resize: 'horizontal'
        },
        csvText: 'name',
        csvFormatter: this.exportDetailLink,
        formatter: this.renderDetailLink,
        text: 'Bill',
      },
      {
        dataField: 'name',
        hidden: true,
        text: 'Name',
        headerStyle: {
          resize: 'horizontal'
        },
        csvExport: false,
      },
      {
        dataField: 'status',
        sort: true,
        formatter: this.renderStatus,
        headerStyle: {
          width: '100px',
          resize: 'horizontal'
        },
        text: 'Status',
      },
      {
        dataField: 'vendor',
        sort: true,
        headerStyle: {
          width: '100px',
          resize: 'horizontal'
        },
        text: 'Merchant',
      },
      {
        dataField: 'item_price',
        sort: true,
        text: 'Total Item Price',
        formatter: this.renderPrice,
        headerStyle: {
          width: '120px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'order_count',
        sort: true,
        text: 'No. of Orders',
        hidden: !isAdmin,
        headerStyle: {
          width: '120px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'total_discount',
        sort: true,
        formatter: this.renderDiscount,
        headerStyle: {
          width: '120px',
          resize: 'horizontal'
        },
        text: 'Total Discount',
      },
      {
        dataField: 'commission',
        sort: true,
        text: 'Total Commission',
        formatter: this.renderCommission,
        csvFormatter: this.exportCommission,
        headerStyle: {
          width: '140px',
          resize: 'horizontal'
        },
        headerFormatter: () => {
          return (
            <>
              <span data-tip="Included Commission Adjust. (if any)">Total Commission <i className="fa fa-info-circle"></i></span><ReactTooltip />
            </>
          )
        }
      },
      {
        dataField: 'gst',
        sort: true,
        formatter: this.renderGst,
        csvFormatter: this.exportTax,
        headerStyle: {
          width: '100px',
          resize: 'horizontal'
        },
        text: 'Total SST',
        headerFormatter: () => {
          return (
            <>
              <span data-tip="Included SST Adjust. (if any)">Total SST <i className="fa fa-info-circle"></i></span><ReactTooltip />
            </>
          )
        }
      },
      {
        dataField: 'total_shipping',
        sort: true,
        formatter: this.renderShipping,
        headerStyle: {
          width: '120px',
          resize: 'horizontal'
        },
        text: 'Total Shipping',
      },
      {
        dataField: 'balance',
        sort: true,
        formatter: this.renderPrice,
        headerStyle: {
          width: '125px',
          resize: 'horizontal'
        },
        text: 'Total Payout Bal.',
      },
      {
        dataField: 'invoice_number',
        formatter: this.renderInvoiceNumber,
        sort: true,
        headerStyle: {
          width: '145px',
          resize: 'horizontal'
        },
        text: 'Invoice Number',
      },
      {
        dataField: 'has_eInvoice',
        formatter: this.renderEInvoice,
        sort: true,
        headerStyle: {
          width: '150px',
          resize: 'horizontal'
        },
        text: 'e-Invoice Seller',
      },
      {
        dataField: 'e_invoice_requested',
        formatter: this.renderEInvoice,
        sort: true,
        headerStyle: {
          width: '110px',
          resize: 'horizontal'
        },
        text: 'e-Invoice',
      },
      {
        dataField: 'invoice_link',
        hidden: true,
        sort: true,
        text: 'Invoice Link',
      },
      {
        dataField: 'bank_name',
        hidden: true,
        sort: true,
        text: 'Bank Name',
      },
      {
        dataField: 'acc_no',
        hidden: true,
        sort: true,
        text: 'Account Number',
      },
      {
        dataField: 'acc_name',
        hidden: true,
        sort: true,
        text: 'Account Name',
      },
      {
        dataField: 'swift_code',
        hidden: true,
        sort: true,
        text: 'Swift Code',
      },
      {
        dataField: 'email',
        hidden: true,
        sort: true,
        text: 'Email',
      },
    ];

    return (
      <div>
        <TabHeader
          title="Billings"
          tab_id="billings"
          user={user}
          children={
            <>
              {
                (isAdmin || isStaff) &&
                <div className="col-xs-12 col-sm-9 col-lg-6 col-xl-5">
                  <Row className="justify-content-md-end">
                    <Col xs={7}>{this.renderBillName(period, this.handleOnExportBillNameChange)}</Col>
                    <Col xs="auto"><Button variant="primary" onClick={this.handleExportMonthlyBill}>{exportingBill ? "Generating" : "Export Bill" }</Button></Col>
                  </Row>
                </div>
              }
            </>
          }
        />
        <Accordion style={{borderRadius: '18px'}} className="dashboard-card shadow-sm" defaultActiveKey="0">
          <Accordion.Item style={{borderRadius: '18px', border: 'none'}} eventKey="0">
            <Accordion.Header><h5 style={{marginBottom: '0'}}>Filters</h5></Accordion.Header>
            <Accordion.Body>
              <div className="row">
                <div className="col-sm-9">
                  <div className="row">
                    <div className="col-xs-12 col-sm-5 col-xl-4 mb-3 mb-sm-3">
                      <Form.Select value={startMonthName} className="form-control" onChange={this.handleStartPeriodChange}>
                        <option key="1" value="" hidden>Select start month</option>
                        {
                          period.map(option => {
                            return (<option key={option.format('MMM YYYY')} value={option.format('MMM YYYY')}>{option.format('MMM YYYY')}</option>)
                          })
                        }
                      </Form.Select>
                    </div>
                    <div className="col-xs-12 col-sm-5 col-xl-4 mb-3 mb-sm-3">
                      <Form.Select value={endMonthName} className="form-control" onChange={this.handleEndPeriodChange}>
                        <option key="1" value="" hidden>Select end month</option>
                        {
                          period.map(option => {
                            return (<option key={option.format('MMM YYYY')} value={option.format('MMM YYYY')}>{option.format('MMM YYYY')}</option>)
                          })
                        }
                    </Form.Select>
                    </div>
                  </div>
                </div>

                <div className="filter-buttons col-sm-3 d-flex flex-sm-column flex-lg-row justify-content-between my-2 mb-auto">
                <Button
                    className="apply-filter col-xs-6 mx-2 mb-2 mb-lg-0"
                    variant="secondary"
                    style={{width: '100%'}}
                    onClick={this.handleResetFilter}
                  >Reset
                  </Button>
                <Button
                    className="apply-filter col-xs-6 mx-2 mb-2 mb-lg-0"
                    variant="primary"
                    style={{width: '100%'}}
                    onClick={this.handleOnClickFilter}
                  >Apply
                  </Button>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {
          !loading && (isAdmin || isStaff) &&
          <Row className="my-3 justify-content-end">
            <Col sm="auto">
              <Button className="btn-br-6" variant="primary" disabled={selectedBilledIds.length === 0} onClick={this.handleOnClickUpdatePaymentDate}>Update Payment Date for {selectedBilledIds.length} bill(s)</Button>
            </Col>
            <Col sm="auto">
              <Button className="btn-br-6" variant="primary" disabled={selectedUnbilledIds.length === 0} onClick={this.handleOnClickConfirmBill}>Confirm {selectedUnbilledIds.length} bill(s)</Button>
            </Col>
          </Row>
        }
        {
          loading &&
          <Loader />
        }
        {
          !loading && items &&
          <Container fluid className="mb-1 mt-4 d-flex gap-2 flex-row flex-wrap">
            {[['all', 'All'], ['unbilled', 'Unbilled'], ['billed', 'Billed'], ['paid', 'Paid']].map(([value, label]) => (
              <Button
                key={value}
                variant={statusFilter === value ? 'primary' : 'outline-secondary'}
                className="btn-br-6 me-2 mb-2"
                onClick={() => this.handleStatusFilterChange(value)}
              >
                {label} ({statusCounts[value]})
              </Button>
            ))}
          </Container>
        }
        {
          !loading && items &&
            <ToolkitProvider
              keyField='_id'
              data={filteredItems}
              columns={columns}
              exportCSV={{
                exportAll: false
              }}
              search
            >
              {
                props => (
                  <>
                    <Container fluid className="mb-3 mt-4 d-flex gap-3 flex-row flex-wrap">
                      <Col>
                        { !isStaff &&
                        <ExportCSVButton
                          className="btn-info"
                          style={{borderRadius:'8px'}}
                          { ...props.csvProps }
                        ><FontAwesomeIcon icon={solid('arrow-right-from-bracket')} transform="rotate--90" style={{marginRight: '15px'}}/>
                          Export to CSV</ExportCSVButton>
                        }
                      </Col>
                      <Col xs={4}>
                        <SearchBar { ...props.searchProps }
                        style={{borderRadius:'25px'}} placeholder="Search"/>
                      </Col>
                    </Container>
                    <BootstrapTable
                      { ...props.baseProps }
                      bordered={ false }
                      selectRow={selectRowProp}
                      pagination={paginationFactory(options)}
                      hover
                      defaultSorted={[{
                        dataField: '_id',
                          order: 'desc',
                      }]}
                    />
                  </>
                )
              }
            </ToolkitProvider>
        }
        {
          showConfirmBillModal &&
          <ConfirmModal onClickYes={this.handleConfirmBills} onClose={this.handleOnCloseConfirmBillModal} title="Confirm Bills">
            <p>Confirm {selectedUnbilledIds.length} bills?</p>
          </ConfirmModal>
        }
        {
          showUpdatePaymentDateModal &&
          <PaymentDateModal bills={selectedBilledIds} onClose={this.handleOnCloseShowPaymentDateModal} onClickSave={this.handleSetPaymentDate}/>
        }
        {
          (isAdmin || isStaff) && showFailedBillsSection &&
          <Card className="shadow-sm mt-4">
            <Card.Body>
              {confirming && confirmTotal > 0 &&
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <strong>Confirming bills… {confirmDone} of {confirmTotal}</strong>
                    <span className="text-muted">{queueWorking ? 'Working' : 'Finishing…'}</span>
                  </div>
                  <ProgressBar now={confirmPct} label={`${confirmPct}%`} striped animated={queueWorking} />
                </div>
              }
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="mb-0">Failed bills ({deadLetter.length})</h5>
                <div>
                  <Button variant="outline-secondary" size="sm" className="me-2" onClick={this.fetchDeadLetter} disabled={deadLetterLoading}>Refresh</Button>
                  <Button variant="outline-danger" size="sm" onClick={this.handleClearDeadLetter} disabled={deadLetterLoading || deadLetter.length === 0}>Clear</Button>
                </div>
              </div>
              {deadLetterLoading && <div>Loading failed bills…</div>}
              {deadLetterError && <div className="text-danger">{deadLetterError}</div>}
              {!deadLetterLoading && !deadLetterError && deadLetter.length === 0 && <div className="text-muted">No failed bills.</div>}
              {!deadLetterLoading && !deadLetterError && deadLetter.length > 0 &&
                <div className="table-responsive">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Bill ID</th>
                        <th>Reason</th>
                        <th>Failed at</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {deadLetter.map((entry) => (
                        <tr key={entry.billId + entry.failed_at}>
                          <td><code>{entry.billId}</code></td>
                          <td>{entry.reason}</td>
                          <td>{entry.failed_at}</td>
                          <td className="text-end">
                            <Button variant="primary" size="sm" onClick={() => this.handleRequeueDeadLetter(entry.billId)}>Retry</Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              }
            </Card.Body>
          </Card>
        }
      </div>
    );
  }
}

export default connect((state, props) => {
  const { pathname, search, routeState } = props.location;
  let previousRoutePathName;
  let previousRouteSearch;
  if (routeState && routeState.previousRoutes && routeState.previousRoutes.length) {
    const previousRoute = routeState.previousRoutes[routeState.previousRoutes.length - 1];
    previousRoutePathName = previousRoute.indexOf('?') > -1 ? previousRoute.substr(0, previousRoute.indexOf('?')) : previousRoute;
    previousRouteSearch = previousRoute.indexOf('?') > -1 ? previousRoute.substr(previousRoute.indexOf('?')) : null;
  }
  return {
    user: state.auth.user,
    billings: state.billings,
    previousRoutePathName,
    previousRouteSearch,
    previousRoutes: (routeState && routeState.previousRoutes && routeState.previousRoutes.length) ? [...routeState.previousRoutes, `${pathname}${search}`] : [`${pathname}${search}`],
    previousPreviousRoutes: (routeState && routeState.previousRoutes && routeState.previousRoutes.length) ? routeState.previousRoutes.slice(0, routeState.previousRoutes.length - 1) : null
  };
}, billingsActionCreators)(Billings);
